/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;

export const LOAD_PACKAGES_LIST = `${url}/LOAD_PACKAGES_LIST`;
export const LOAD_PACKAGES_LIST_SUCCESS = `${url}/LOAD_PACKAGES_LIST_SUCCESS`;
export const LOAD_PACKAGES_LIST_ERROR = `${url}/LOAD_PACKAGES_LIST_ERROR`;
export const LOAD_PACKAGES_TOTAL_LIST = `${url}/LOAD_PACKAGES_TOTAL_LIST`;
export const LOAD_PACKAGES_TOTAL_LIST_SUCCESS = `${url}/LOAD_PACKAGES_TOTAL_LIST_SUCCESS`;
export const LOAD_PACKAGES_TOTAL_LIST_ERROR = `${url}/LOAD_PACKAGES_TOTAL_LIST_ERROR`;
export const LOAD_DESTINATION_SEARCH_LIST = `${url}/LOAD_DESTINATION_SEARCH_LIST`;
export const LOAD_DESTINATION_SEARCH_LIST_SUCCESS = `${url}/LOAD_DESTINATION_SEARCH_LIST_SUCCESS`;
export const LOAD_DESTINATION_SEARCH_LIST_ERROR = `${url}/LOAD_DESTINATION_SEARCH_LIST_ERROR`;
export const LOAD_PACKAGES_SINGLE_LIST = `${url}/LOAD_PACKAGES_SINGLE_LIST`;
export const LOAD_PACKAGES_SINGLE_LIST_SUCCESS = `${url}/LOAD_PACKAGES_SINGLE_LIST_SUCCESS`;
export const LOAD_PACKAGES_SINGLE_LIST_ERROR = `${url}/LOAD_PACKAGES_SINGLE_LIST_ERROR`;
export const LOAD_TERMS_AND_CONDITIONS_LIST = `${url}/LOAD_TERMS_AND_CONDITIONS_LIST`;
export const LOAD_TERMS_AND_CONDITIONS_LIST_SUCCESS = `${url}/LOAD_TERMS_AND_CONDITIONS_LIST_SUCCESS`;
export const LOAD_TERMS_AND_CONDITIONS_LIST_ERROR = `${url}/LOAD_TERMS_AND_CONDITIONS_LIST_ERROR`;
export const LOAD_TERMS_SINGLE_CONDITIONS_LIST = `${url}/LOAD_TERMS_SINGLE_CONDITIONS_LIST`;
export const LOAD_TERMS_SINGLE_CONDITIONS_LIST_SUCCESS = `${url}/LOAD_TERMS_SINGLE_CONDITIONS_LIST_SUCCESS`;
export const LOAD_TERMS_SINGLE_CONDITIONS_LIST_ERROR = `${url}/LOAD_TERMS_SINGLE_CONDITIONS_LIST_ERROR`;
export const LOAD_PACKAGES_FAQ_LIST = `${url}/LOAD_PACKAGES_FAQ_LIST`;
export const LOAD_PACKAGES_FAQ_LIST_SUCCESS = `${url}/LOAD_PACKAGES_FAQ_LIST_SUCCESS`;
export const LOAD_PACKAGES_FAQ_LIST_ERROR = `${url}/LOAD_PACKAGES_FAQ_LIST_ERROR`;
export const LOAD_PACKAGES_FAQ_MAIN_LIST = `${url}/LOAD_PACKAGES_FAQ_MAIN_LIST`;
export const LOAD_PACKAGES_FAQ_MAIN_LIST_SUCCESS = `${url}/LOAD_PACKAGES_FAQ_MAIN_LIST_SUCCESS`;
export const LOAD_PACKAGES_FAQ_MAIN_LIST_ERROR = `${url}/LOAD_PACKAGES_FAQ_MAIN_LIST_ERROR`;
export const LOAD_TRAVELLER_AGE_RESTRICTIONS = `${url}/LOAD_TRAVELLER_AGE_RESTRICTIONS`;
export const LOAD_TRAVELLER_AGE_RESTRICTIONS_SUCCESS = `${url}/LOAD_TRAVELLER_AGE_RESTRICTIONS_SUCCESS`;
export const LOAD_TRAVELLER_AGE_RESTRICTIONS_ERROR = `${url}/LOAD_TRAVELLER_AGE_RESTRICTIONS_ERROR`;

export const LOAD_PACKAGES_LIST_RECORDS_META_DATA = `${url}/LOAD_PACKAGES_LIST_RECORDS_META_DATA`;
export const LOAD_PACKAGES_LIST_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_PACKAGES_LIST_RECORDS_META_DATA_SUCCESS`;
export const LOAD_PACKAGES_LIST_RECORDS_META_DATA_ERROR = `${url}/LOAD_PACKAGES_LIST_RECORDS_META_DATA_ERROR`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

const constants = {
  LOAD_PACKAGES_LIST,
  LOAD_PACKAGES_LIST_SUCCESS,
  LOAD_PACKAGES_LIST_ERROR,
  LOAD_PACKAGES_TOTAL_LIST,
  LOAD_PACKAGES_TOTAL_LIST_SUCCESS,
  LOAD_PACKAGES_TOTAL_LIST_ERROR,
  LOAD_DESTINATION_SEARCH_LIST,
  LOAD_DESTINATION_SEARCH_LIST_SUCCESS,
  LOAD_DESTINATION_SEARCH_LIST_ERROR,
  LOAD_PACKAGES_SINGLE_LIST,
  LOAD_PACKAGES_SINGLE_LIST_SUCCESS,
  LOAD_PACKAGES_SINGLE_LIST_ERROR,
  LOAD_TERMS_AND_CONDITIONS_LIST,
  LOAD_TERMS_AND_CONDITIONS_LIST_SUCCESS,
  LOAD_TERMS_AND_CONDITIONS_LIST_ERROR,
  LOAD_TERMS_SINGLE_CONDITIONS_LIST,
  LOAD_TERMS_SINGLE_CONDITIONS_LIST_SUCCESS,
  LOAD_TERMS_SINGLE_CONDITIONS_LIST_ERROR,
  LOAD_PACKAGES_FAQ_LIST,
  LOAD_PACKAGES_FAQ_LIST_SUCCESS,
  LOAD_PACKAGES_FAQ_LIST_ERROR,
  LOAD_PACKAGES_FAQ_MAIN_LIST,
  LOAD_PACKAGES_FAQ_MAIN_LIST_SUCCESS,
  LOAD_PACKAGES_FAQ_MAIN_LIST_ERROR,
  LOAD_TRAVELLER_AGE_RESTRICTIONS,
  LOAD_TRAVELLER_AGE_RESTRICTIONS_SUCCESS,
  LOAD_TRAVELLER_AGE_RESTRICTIONS_ERROR,

  LOAD_PACKAGES_LIST_RECORDS_META_DATA,
  LOAD_PACKAGES_LIST_RECORDS_META_DATA_SUCCESS,
  LOAD_PACKAGES_LIST_RECORDS_META_DATA_ERROR,
};

export default constants;
